module.exports = __webpack_public_path__ + "img/cti.f736d62f.png";